export default __webpack_public_path__ + "static/media/img15.44cc136e.png";